import AddUserGroupContainer from "./AddUserGroupContainer";

export default function AddUserGroup(props: {
  onModal: (type?: string) => void;
}): JSX.Element {
  return <AddUserGroupContainer {...props} />;
}
